import React, { useRef, useEffect, memo } from 'react'
import IframeBubble from './IframeBubble'

type PaymentWidgetProps = {
  readonly src: string
  readonly title?: string
  readonly height?: number
  readonly className?: string
  readonly assistantMessage?: string
}

const PaymentWidget = memo(function PaymentWidget({
  src,
  title = 'Payment Widget',
  height = 400,
  className = '',
  assistantMessage,
}: PaymentWidgetProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handlePaymentMessage = (event: MessageEvent) => {
      if (
        event.data &&
        (event.data.type === 'payment_success' || event.data.type === 'payment_error')
      ) {
        if (event.data.redirect_url) {
          window.location.href = event.data.redirect_url
        }
      }
    }

    window.addEventListener('message', handlePaymentMessage)

    return () => {
      window.removeEventListener('message', handlePaymentMessage)
    }
  }, [])

  return (
    <div ref={containerRef} className={className}>
      <IframeBubble
        src={src}
        title={title}
        height={height}
        allowFullscreen={false}
        sandbox='allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation'
        assistantMessage={assistantMessage}
      />
    </div>
  )
})

export default PaymentWidget
